import { cloneDeep, set } from 'lodash'
import { useRef, useState } from 'react'
import ColorInput from 'components/ColorInput/ColorInput'
import { ReactComponent as ImageIcon } from 'assets/icons/image.svg'
import { ReactComponent as PaintBucketIcon } from 'assets/icons/color-bucket.svg'
import MediaLibrary from '../../components/MediaLibrary/MediaLibrary'
import clsx from 'clsx'
import { ReactComponent as AlignTopIcon } from 'assets/icons/align-top.svg'
import { ReactComponent as AlignCenterIcon } from 'assets/icons/align-center.svg'

import IconMenu from '../../components/IconMenu/IconMenu'
import PortfolioBackgroundImageModal from './modals/PortfolioBackgroundImageModal'

//todo rewrite passing in theme instead of region
const PortfolioRegionSettings = ({ region, values, onChange }) => {
  const pageData = values?.pageData || {}
  const theme = pageData?.theme || 'dark'
  const iconColor = theme === 'dark' ? '#ccc' : '#676767'
  const regionData = pageData?.[region] || {}
  const [backgroundImageModalIsOpen, setBackgroundImageModalIsOpen] =
    useState(false)
  const containerRef = useRef()
  const showVerticalAlignment = ![
    'profileTop',
    'profileBottom',
    'playerOnly',
  ].includes(pageData?.template)

  function handleRegionChange(name, value) {
    const newValues = cloneDeep(values)
    set(newValues, ['pageData', region, name], value)
    onChange(newValues)
  }

  function handleBackgroundImageSubmit(background) {
    const currentValues = regionData?.background || {}
    if (background) {
      handleRegionChange('background', { ...currentValues, ...background })
    } else {
      handleRegionChange('background', {
        ...(currentValues?.color ? { color: currentValues?.color } : {}),
      })
    }

    setBackgroundImageModalIsOpen(false)
  }

  function handleChangeBackgroundColor(color) {
    const currentValues = regionData?.background || {}
    handleRegionChange('background', { ...currentValues, color })
  }

  function getVerticalAlignIcon() {
    const alignment = regionData?.verticalAlign
    if (alignment === 'center') {
      return (
        <AlignCenterIcon fill={iconColor} width="22" className="-rotate-90" />
      )
    }
    if (alignment === 'flex-end') {
      return <AlignTopIcon fill={iconColor} width="22" className="rotate-180" />
    }

    return <AlignTopIcon fill={iconColor} width="22" />
  }

  return (
    <div
      ref={containerRef}
      className=" relative h-[32px] flex items-center flex-fill z-10"
    >
      <div
        className={clsx(
          'bg-deep w-[40px] h-[32px] ml-8 flex justify-center items-center rounded-l',
          {
            'bg-deep': theme === 'dark',
            'bg-white': theme === 'light',
          },
        )}
      >
        <ColorInput
          tooltip="Background Color"
          hideInput
          hideColorPreview
          containerClass="flex justify-center items-center"
          value={regionData.backgroundColor}
          containerRef={containerRef}
          icon={<PaintBucketIcon fill={iconColor} height="22" />}
          alpha={true}
          onChange={handleChangeBackgroundColor}
        />
      </div>
      <div
        className={clsx(
          'w-[40px] h-[32px] flex justify-center items-center rounded-r',
          {
            'bg-deep': theme === 'dark',
            'light-bg': theme === 'light',
          },
        )}
      >
        <button
          className="flex-fill flex justify-center items-center"
          data-tooltip="Background Image"
          onClick={() => setBackgroundImageModalIsOpen(true)}
        >
          <ImageIcon
            fill={iconColor}
            width="24"
            height="24"
            alt="Set Background Image"
          />
        </button>
      </div>
      <div
        className={clsx('w-[1px] h-[32px] mx-2', {
          'bg-gray-bright': theme === 'dark',
          'bg-white-med': theme === 'light',
        })}
      ></div>
      {showVerticalAlignment ? (
        <IconMenu
          containerClass="ml-2"
          icon={getVerticalAlignIcon()}
          tooltip="Vertical Align"
        >
          <button
            onClick={() => handleRegionChange('verticalAlign', 'flex-start')}
            className={clsx({
              'is-active': regionData?.verticalAlign === 'flex-start',
            })}
          >
            <AlignTopIcon fill="#ccc" width="22" />
            Top
          </button>
          <button
            onClick={() => handleRegionChange('verticalAlign', 'center')}
            className={clsx({
              'is-active': regionData?.verticalAlign === 'center',
            })}
          >
            <AlignCenterIcon fill="#ccc" width="22" className="-rotate-90" />
            Center
          </button>
          <button
            onClick={() => handleRegionChange('verticalAlign', 'flex-end')}
            className={clsx({
              'is-active': regionData?.verticalAlign === 'flex-end',
            })}
          >
            <AlignTopIcon fill="#ccc" width="22" className="rotate-180" />
            Bottom
          </button>
        </IconMenu>
      ) : null}

      {backgroundImageModalIsOpen ? (
        <PortfolioBackgroundImageModal
          isOpen={backgroundImageModalIsOpen}
          onRequestClose={() => setBackgroundImageModalIsOpen(false)}
          initialValues={regionData?.background}
          onSubmit={handleBackgroundImageSubmit}
        />
      ) : null}
    </div>
  )
}

export default PortfolioRegionSettings
